/** Cadê o carro? — cliente. Online (posição + foto exigem rede). */
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import type { PutAssinado } from '../memorias/api';

export interface Carro {
  id: string;
  latitude: number;
  longitude: number;
  note: string | null;
  familyId: string | null;
  parkedBy: { memberId: string; name: string };
  parkedAt: string;
  expiresAt: string;
  photoUrl: string | null;
}

async function pedir<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, { credentials: 'same-origin', ...init, headers: { ...(init?.body ? { 'content-type': 'application/json' } : {}), ...(init?.headers ?? {}) } });
  if (!res.ok) {
    const corpo = (await res.json().catch(() => ({}))) as { message?: string };
    throw new Error(corpo.message ?? `Falha (${res.status})`);
  }
  return (await res.json()) as T;
}

export const carroApi = {
  atual: (tripId: string) => pedir<{ car: Carro | null }>(`/api/v1/trips/${tripId}/car`),
  estacionar: (tripId: string, input: { id: string; latitude: number; longitude: number; note?: string | null; photo?: { mimeType: string; bytes: number } | null }) =>
    pedir<{ car: Carro; upload: PutAssinado | null }>(`/api/v1/trips/${tripId}/car`, { method: 'POST', body: JSON.stringify(input) }),
  fotoPronta: (tripId: string, carId: string) => pedir<{ car: Carro }>(`/api/v1/trips/${tripId}/car/${carId}/photo-complete`, { method: 'POST', body: '{}' }),
  peguei: (tripId: string, carId: string) => pedir<{ ok: true }>(`/api/v1/trips/${tripId}/car/${carId}/release`, { method: 'POST' }),
};

export function useCarro(tripId: string, ligado = true) {
  return useQuery({ queryKey: ['carro', tripId], queryFn: () => carroApi.atual(tripId), enabled: ligado, refetchInterval: ligado ? 60_000 : false, staleTime: 20_000 });
}

export function useInvalidarCarro(tripId: string) {
  const cliente = useQueryClient();
  useEffect(() => {
    const ao = () => void cliente.invalidateQueries({ queryKey: ['carro', tripId] });
    window.addEventListener('nv:carro-mudou', ao);
    return () => window.removeEventListener('nv:carro-mudou', ao);
  }, [cliente, tripId]);
  return () => window.dispatchEvent(new Event('nv:carro-mudou'));
}
